var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expandable-drawer-container",on:{"click":_vm.onClick}},[_c('div',[_vm._t("collapsed")],2),_c('div',{style:(_vm.getExpandedSlotStyle)},[_vm._t("expanded")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }